"use client";
import { type PageLoadEventInput, pageLoadEvent } from "@/lib/atInternetTags";
import { useEffect } from "react";

export const PageLoad = ({ page, page_chapter1, page_chapter2, page_chapter3, site_level2 }: PageLoadEventInput) => {
  useEffect(() => {
    pageLoadEvent({ page, page_chapter1, page_chapter2, page_chapter3, site_level2 });
  }, [page, page_chapter1, page_chapter2, page_chapter3, site_level2]);

  return null;
};
